export const ECOMMERCE_EVENT = {
  /**
   * When results are viewed in Dream Search
   */
  VIEW_ITEM_LIST: "view_item_list" as const,
  /**
   * When favoriting an item in Dream Search
   */
  ADD_TO_WISHLIST: "add_to_wishlist" as const,
  /**
   * When clicking through a result to the program page
   */
  VIEW_ITEM: "view_item" as const,
  /**
   * When clicking either the "Select class" button for a class or the
   * "Get started" button for a program
   */
  ADD_TO_CART: "add_to_cart" as const,
  /**
   * When clicking the "Get Started" button on the program page
   */
  BEGIN_CHECKOUT: "begin_checkout" as const,
  /**
   * When a customer makes a payment toward their enrollment
   */
  PURCHASE: "purchase" as const,
};

export type ResultItemForEcommerce = {
  provider: {
    id: string;
    fullName: string;
  };
  program: {
    id: string;
    name?: string | null;
    vocation: {
      id: string;
      adjective: string;
    };
  };
};

type EcommerceItem = {
  item_id: string;
  item_name?: string;
  index?: number;
  item_category: "Program" | "Unknown";
  dream_provider_id?: string;
  dream_provider_name?: string;
  dream_program_vocation_id?: string;
  dream_program_vocation_adjective?: string;
};

export const dreamSearchItemToEcommerceItem = (data: ResultItemForEcommerce): EcommerceItem => ({
  item_id: data.program.id,
  ...(data.program.name && { item_name: data.program.name }),
  item_category: "Program",
  dream_provider_id: data.provider.id,
  dream_provider_name: data.provider.fullName,
  dream_program_vocation_id: data.program.vocation.id,
  dream_program_vocation_adjective: data.program.vocation.adjective,
});

export type EventName = (typeof ECOMMERCE_EVENT)[keyof typeof ECOMMERCE_EVENT];
export type DataLayerEvent = {
  event: EventName;
  ecommerce: {
    items: EcommerceItem[];
  };
};
